import { types } from 'mobx-state-tree';

import { CouponDiscountTypeType } from '../types/CouponDiscountType';
import { CampaignCodeTypeType } from '../types/CampaignCodeType';

const Discount = types.model('Discount', {
  allow_sale_products: types.boolean,
  amount: types.maybeNull(types.number),
  limited_to_categories: types.maybeNull(types.array(types.number)),
  limited_to_manufacturers: types.maybeNull(types.array(types.string)),
  limited_to_products: types.maybeNull(types.array(types.string)),
  percentage: types.maybeNull(types.number),
  type: CouponDiscountTypeType
});

const CampaignCode = types.model('CampaignCode', {
  code: types.string,
  discounts: types.optional(types.array(Discount), []),
  type: CampaignCodeTypeType
});

export default CampaignCode;



// WEBPACK FOOTER //
// ./src/models/CampaignCode.js